import intersection from 'lodash/intersection';

import { IPermissionSubjectValues } from 'types/IPermissionSubjects';

function isScmToolPermissionPresent(
  scmToolRequiredSubjects: Array<IPermissionSubjectValues>,
  currentUserPermissionSubjects: Array<IPermissionSubjectValues>
): boolean {
  if (
    scmToolRequiredSubjects?.length === 0 ||
    currentUserPermissionSubjects?.length === 0
  )
    return false;

  return (
    intersection(scmToolRequiredSubjects, currentUserPermissionSubjects)
      .length > 0
  );
}

export default isScmToolPermissionPresent;
